import React, { useRef, useState, useEffect, useMemo, memo } from 'react';
import styles from './officeHourModal.module.scss';

export const CountDown = memo(({ timeInSec, onCountDownHitZero }: { timeInSec: number; onCountDownHitZero?: () => void }) => {
  const [timeLeft, setTimeLeft] = useState(timeInSec);
  let countDownTimer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timeLeft < 2) {
      if (countDownTimer.current) {
        clearInterval(countDownTimer.current)
        countDownTimer.current = null;
      }
      onCountDownHitZero?.();
    }
  }, [onCountDownHitZero, timeLeft]);

  useEffect(() => {
    if (countDownTimer.current) {
      clearInterval(countDownTimer.current)
      countDownTimer.current = null;
    }
    if (timeInSec > 0) {
      setTimeLeft(timeInSec);
      countDownTimer.current = setInterval(() => {
        setTimeLeft(prevState => prevState > 1 ? prevState - 1 : 1);
      }, 1000);
    } else {
      setTimeLeft(0);
    }
    return () => {
      if (countDownTimer.current) {
        clearInterval(countDownTimer.current)
        countDownTimer.current = null;
      }
    }
  }, [timeInSec]);

  const { days, hours, minutes, seconds } = useMemo(() => {
    const days = Math.floor(timeLeft / (60 * 60 * 24));
    const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((timeLeft % (60 * 60)) / 60);
    const seconds = Math.floor(timeLeft % 60);
    return { days, hours, minutes, seconds };
  }, [timeLeft]);

  return (
    <div className={styles.countDownDivContainer}>
      <div className={styles.countDownContainer}>
        <div className={styles.countDownBox}>
          <div className={styles.countDownNumber}>{days}</div>
          <div className={styles.countDownNumberDesc}>Days</div>
        </div>
        <div className={styles.countDownBox}>
          <div className={styles.countDownNumber}>{hours}</div>
          <div className={styles.countDownNumberDesc}>Hours</div>
        </div>
        <div className={styles.countDownBox}>
          <div className={styles.countDownNumber}>{minutes}</div>
          <div className={styles.countDownNumberDesc}>Minutes</div>
        </div>
        <div className={styles.countDownBox}>
          <div className={styles.countDownNumber}>{seconds}</div>
          <div className={styles.countDownNumberDesc}>Seconds</div>
        </div>
      </div>
    </div>
  )
})
